import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './SettingsLayout.resolver';
import SettingsLayout from './SettingsLayout';

export default async(resolver, { context: RootStoreContext })(SettingsLayout);
